import styled, { css } from 'styled-components';
import { styles } from '4all-ui/styles';
import { container } from '../../../../styles/mixins';
import { getIsDraggingStyle } from '../../style';

export const Content = styled.div`
  background-color: ${styles.colors.WHITE};
  box-shadow: 0 0 10px 3px rgba(0, 0, 0, 0.05);
  ${container()};
  margin-bottom: 20px;
  padding: 0 30px;

  ${({ isDragging }) =>
    css`
      ${getIsDraggingStyle(isDragging)}}
      margin-top: ${isDragging ? '10px' : '0'};
      ${isDragging && 'margin-left: 50px'}
    `}

  .Collapsible__contentInner {
    margin: 0 -30px;
  }
`;



// WEBPACK FOOTER //
// ./src/screens/Product/Categories/CategoryItem/style.js